import React, { useMemo } from "react";
import {
  Stack,
  StackDivider,
  Center,
  Text,
  Box,
  SimpleGrid,
  Image,
  Badge,
  Heading,
  ChakraProps,
} from "@ssg-ui/react";
import { chunk } from "lodash";

interface Props extends ChakraProps {
  data?: {
    imageSrc: string;
    title: string;
    isNew: string;
    isAdvertised: string;
  }[];
  title?: string;
  columns: number;
}

export const DividerThumbnailList = (props: Props) => {
  const { title, data, columns, ...rest } = props;
  const chunks = useMemo(() => chunk(data, columns), [data, columns]);

  return (
    <Box w="full" {...rest}>
      {title && (
        <Box mb={4}>
          <Heading as="h3" fontSize="2xl">
            {title}
          </Heading>
        </Box>
      )}
      <Stack
        spacing={0}
        divider={<StackDivider />}
        borderTopWidth="1px"
        borderBottomWidth="1px"
      >
        {chunks?.map((chunk, rowIndex) => (
          <SimpleGrid key={rowIndex} columns={columns}>
            {chunk?.map((item) => {
              return (
                <Box
                  key={item.title}
                  borderLeftWidth="1px"
                  pb="2"
                  _first={{ borderLeftWidth: 0 }}
                >
                  <Box position="relative" py="2" px="3">
                    <Box position="relative" overflow="hidden" h="30px">
                      <Image
                        src={item.imageSrc}
                        alt={item.title}
                        maxW="74px"
                        objectFit="cover"
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%,-50%)"
                      />
                    </Box>
                    {item.isAdvertised === "Y" && (
                      <Badge
                        variant="solid"
                        colorScheme="gray"
                        position="absolute"
                        top="0"
                        right="0"
                      >
                        ad
                      </Badge>
                    )}
                    {item.isNew === "Y" && (
                      <Badge
                        variant="solid"
                        position="absolute"
                        top="0"
                        right="0"
                      >
                        open
                      </Badge>
                    )}
                  </Box>
                  <Center>
                    <Text fontSize="sm">{item.title}</Text>
                  </Center>
                </Box>
              );
            })}
          </SimpleGrid>
        ))}
      </Stack>
    </Box>
  );
};

DividerThumbnailList.defaultProps = {
  title: "타이틀",
  columns: 3,
  data: [
    {
      title: "메이크업포에버",
      linkUrl:
        "https://m.shinsegaemall.ssg.com/specialStore/makeupforever/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/202008/2020081309032850800991929099_419.jpg",
    },
    {
      id: "",
      title: "더비비고",
      linkUrl:
        "https://m.shinsegaemall.ssg.com/specialStore/thebibigo/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/202011/2020110414442374423318560431_938.png",
      isAdvertised: "Y",
      isNew: "N",
    },
    {
      id: "",
      title: "오설록",
      linkUrl:
        "https://m.shinsegaemall.ssg.com/specialStore/osulloc/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/202010/2020102009530936449851276985_582.png",
      isAdvertised: "N",
      isNew: "Y",
    },
    {
      id: "",
      title: "노브랜드",
      linkUrl:
        "https://m.emart.ssg.com/specialStore/nobrand/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/201907/2019070517084893210955207095_101.png",
      isAdvertised: "N",
      isNew: "N",
    },
    {
      id: "",
      title: "피코크",
      linkUrl:
        "https://m.emart.ssg.com/specialStore/ssgpeacock/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/201907/2019070517090299932787088278_528.png",
      isAdvertised: "N",
      isNew: "N",
    },
    {
      id: "",
      title: "GUCCI",
      linkUrl:
        "https://m.shinsegaemall.ssg.com/special/gucci/main.ssg?tarea=store6005ssgdot",
      imageSrc:
        "https://sui.ssgcdn.com/cmpt/ctg/201907/2019070516574566068848131984_839.png",
      isAdvertised: "N",
      isNew: "N",
    },
  ],
};
